import { drilldownDataCorporate, ModuleFields } from "~/Utils/drilldownDataDum";

export const mapFields = (data: ModuleFields[]) => {
  return data.map(({ fieldName, placeholder, name, formType, validation, className, hidden,futureDateRestriction,usedFileType}) => ({
    name:name,
    type: formType,
    label: fieldName,
    placeholder:placeholder,
    validation:validation,
    className:className,
    hidden:hidden,
    futureDateRestriction: futureDateRestriction,
    usedFileType
  }));
};

let fields: any = {};

const fieldsReady = new Promise(async (resolve, reject) => {
  try {
    const data = await drilldownDataCorporate();
    fields = {
      news: mapFields(data?.news),
    };
    resolve(fields); 
  } catch (error) {
    reject(error); 
  }
});

export { fields, fieldsReady };
